import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wallet } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (n) => `€${(n ?? 0).toFixed(2)}`;
const pct = (v) => `${Math.round((v ?? 0) * 1000) / 10}%`;

export default function CashbackCard() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/cashback/me").then((r) => setD(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h2 className="font-display font-bold mb-2">Cashback</h2>
      <button data-testid="cashback-link" onClick={() => navigate("/cashback")}
        className="w-full flex items-center justify-between rounded-2xl border border-neutral-200 px-4 py-3 hover:border-black transition-colors">
        <span className="flex items-center gap-2 font-semibold text-sm"><Wallet size={18} />Credito <span data-testid="cashback-card-balance">{fmt(d?.balance)}</span></span>
        <span className="text-xs text-neutral-500">{d ? `${pct(d.effective_pct)} di ogni acquisto` : ""} →</span>
      </button>
    </div>
  );
}
